import { genres } from "@/mocks/comics";

const colorMap: Record<string, { bg: string; text: string; icon: string }> = {
  primary: { bg: "bg-primary-100", text: "text-primary-700", icon: "bg-primary-500" },
  accent: { bg: "bg-accent-100", text: "text-accent-700", icon: "bg-accent-500" },
  secondary: { bg: "bg-secondary-100", text: "text-secondary-800", icon: "bg-secondary-500" },
};

export default function GenresSection() {
  return (
    <section id="genres" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 text-secondary-800 px-3 py-1 text-xs">
              <i className="ri-apps-2-line"></i>全站分类
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">分类浏览</h2>
            <p className="mt-2 text-sm text-foreground-600">按题材快速找到你爱看的韩漫作品</p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {genres.map((g) => {
            const c = colorMap[g.color];
            return (
              <a
                key={g.name}
                href="#updates"
                className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-4 hover:border-primary-300 hover:-translate-y-0.5 transition-all cursor-pointer"
              >
                <span className={`w-12 h-12 shrink-0 rounded-lg ${c.icon} text-background-50 flex items-center justify-center text-xl`}>
                  <i className={g.icon}></i>
                </span>
                <div>
                  <h3 className={`font-medium text-base ${c.text}`}>{g.name}</h3>
                  <p className="mt-0.5 text-xs text-foreground-600">{g.count} 部作品</p>
                </div>
                <i className="ri-arrow-right-line ml-auto text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
              </a>
            );
          })}
        </div>

        <div className="mt-8 rounded-xl overflow-hidden relative">
          <img
            src="https://comtock.github.io/api/search-image?query=colorful%20comic%20book%20illustration%20banner%20with%20stacked%20manhwa%20volumes%20and%20floating%20panels%2C%20vibrant%20warm%20tones%2C%20clean%20modern%20artwork%2C%20energetic%20composition&width=1200&height=420&seq=genres-banner&orientation=landscape"
            alt="韩国漫画yy全站分类作品概览"
            className="w-full h-40 md:h-52 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/70 to-transparent flex items-center">
            <div className="px-6 md:px-10">
              <h3 className="font-heading text-xl md:text-3xl text-white">1200+ 部优质韩漫持续收录</h3>
              <p className="mt-2 text-xs md:text-sm text-white/80">玄幻、恋爱、热血、悬疑……总有你追不完的故事</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}